// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// Containers
import withFormField from '../../containers/with-form-field';

// Styles
import './textarea.scss';

class Textarea extends Component {
    inputRef = React.createRef();

    state = {
        caretPosition: undefined,
    };

    componentDidUpdate() {
        const {caretPosition} = this.state;

        if (this.inputRef.current && (caretPosition || caretPosition === 0)) {
            this.inputRef.current.setSelectionRange(caretPosition, caretPosition);
        }
    }

    onChange = (event) => {
        const {onChange} = this.props;

        event.persist();
        this.setState({caretPosition: event.target.selectionStart});

        onChange(event);
    };

    getProps() {
        const {className, disabled, onBlur, onClick, placeholder, size, type = 'text', value} = this.props;

        return {
            className: classnames(
                {
                    textarea: true,
                },
                className
            ),
            disabled,
            onBlur,
            onChange: this.onChange,
            onClick,
            placeholder,
            ref: this.inputRef,
            size,
            type,
            value,
        };
    }

    render() {
        return <textarea {...this.getProps()} />;
    }
}

Textarea.propTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool,
    onBlur: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    size: PropTypes.number,
    type: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default withFormField(Textarea);
